import union from 'lodash/union';
import without from 'lodash/without';
import last from 'lodash/last';
import head from 'lodash/head';
import { Unit } from './index';

export default class Collection {
  constructor(public items: Unit[] = []) {}

  add(item: Unit) {
    this.items = union(this.items, [item]);
  }

  remove(item: Unit) {
    this.items = without(this.items, item);
  }

  get(i: number) {
    return this.items[i];
  }

  get length() {
    return this.items.length;
  }

  get last() {
    return last(this.items);
  }

  get first() {
    return head(this.items);
  }
}
